import { Injectable } from '@angular/core';
import { SbbNativeDateAdapter } from '@sbb-esta/angular/core';

@Injectable()
export class FzfDateAdapter extends SbbNativeDateAdapter {
  parse(value: any): Date | null {
    if (typeof value === 'number') {
      return new Date(value);
    } else if (typeof value === 'string') {
      return value ? this._parseStringDate(value) || new Date(NaN) : null;
    }
    return new Date(Date.parse(value));
  }
}
